import styled from 'styled-components';

export const Form = styled.form`
	width: 100%;
`;

export const Fieldset = styled.fieldset`
	box-sizing: border-box;
	border-radius: 12px;
	padding: 12px;
	display: flex;
	width: 100%;
	border: 1px solid #ced4da;
	margin: 0;

	&:focus-within {
		border-color: ${({ theme }) => theme.colors.primary.medium};
	}
`;

export const TextInput = styled.input`
	all: unset;
	flex: 1;
	color: ${({ theme }) => theme.colors.neutral.black};

	&::placeholder {
		color: #999;
	}
`;

export const Button = styled.button`
	padding: 0;
	border: none;
	background: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	color: ${({ theme }) => theme.colors.primary.medium};

	&:hover {
		color: ${({ theme }) => theme.colors.primary.light};
	}
`;

export const Label = styled.span`
	display: inline-block;
	margin-bottom: 8px;
`;
